import React from 'react';

interface AboutSectionProps {
  name: string;
  year: string;
}

const AboutSection: React.FC<AboutSectionProps> = ({ name, year }) => {
  return (
    <section className="about-section">
      <div className="about-container">
        <h2 className="section-title">ABOUT ME</h2>
        
        <div className="about-content">
          <div className="about-image-container">
            <img src="/assets/me.png" alt={`${name.split(' ')[0]}`} className="about-image" />
          </div>
          
          <div className="about-text">
            <p className="bio-text">
              Hello! I'm {name.split(' ')[0]}, a passionate web developer with a focus on creating engaging digital experiences. 
              With a background in information technology, I combine technical expertise with creative problem-solving
              to build websites and applications that are both functional and visually appealing.
            </p>
            
            <p className="bio-text">
              My goal is to implement modern, visually appealing, and highly functional websites 
              that showcase expertise and creativity in web development. I believe that great design 
              and clean code go hand in hand.
            </p>
          </div>
          
          <div className="skills-section">
            <h3 className="skills-title">My Skills</h3>
            
            <div className="skills-grid">
              <div className="skill-category">
                <h4 className="category-title">Frontend</h4>
                <ul className="skill-list">
                  <li className="skill-item">React</li>
                  <li className="skill-item">TypeScript</li>
                  <li className="skill-item">JavaScript</li>
                  <li className="skill-item">HTML/CSS</li>
                  <li className="skill-item">Responsive Design</li>
                </ul>
              </div>
              
              <div className="skill-category">
                <h4 className="category-title">Backend</h4>
                <ul className="skill-list">
                  <li className="skill-item">Node.js</li>
                  <li className="skill-item">Express</li>
                  <li className="skill-item">MongoDB</li>
                  <li className="skill-item">RESTful APIs</li>
                  <li className="skill-item">SQL</li>
                </ul>
              </div>
              
              <div className="skill-category">
                <h4 className="category-title">Tools</h4>
                <ul className="skill-list">
                  <li className="skill-item">Git & GitHub</li>
                  <li className="skill-item">VS Code</li>
                  <li className="skill-item">Webpack</li>
                  <li className="skill-item">npm/yarn</li>
                  <li className="skill-item">Docker</li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="experience-section">
            <h3 className="experience-title">Experience</h3>
            
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-date">2023 - Present</div>
                <div className="timeline-content">
                  <h4 className="job-title">Web Developer</h4>
                  <p className="job-description">
                    Building responsive web applications using modern JavaScript frameworks.
                    Working with free lanced clients to deliver high-quality digital solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 